import {
    EquipoLogisticaDTO,
    SomacylEntregablesDTO
} from "sigo-entities";
import { indexedDB } from "../../../useIndexedDB";

export async function helperDeleteInventory(
    _id: string,
    ID_Stock: number,
    invsn: string = '',
    ownPersonal: boolean
) {
    const doc = await indexedDB.somacyl_orders.get(_id)
    if (!doc) throw new Error('Documento no encontrado')

    const inventory = doc.inventory.find(e => e.ID_Stock === ID_Stock && e.invsn === invsn)
    if (!inventory) {
        throw new Error(`Inventario con stock personal ${ID_Stock} no existe en esta orden ${doc.numero_de_peticion}`)
    }

    const item = await indexedDB.items_españa.get({ Codigo: inventory.codigo })
    if (!item) throw new Error('Item no encontrado')

    let equipoStockPersonal: EquipoLogisticaDTO | null = null
    let equipoStockAlmacen: EquipoLogisticaDTO | null = null

    if (inventory.invpool === 'install') {
        if (ownPersonal) {
            const stockPersonal = await indexedDB.stock_personal.get({ ID_StockPersonal: inventory.ID_Stock })
            if (!stockPersonal) throw new Error('Stock personal no encontrado')

            if (stockPersonal.Item.Ind_SB === 'S') {
                const { equipo } = await selectStockPersonalEquipos(inventory.ID_Stock, inventory.invsn)

                equipo.Estado = { ID_Estado: 2, Nombre: 'VALIDADO' }
                equipo.Validado.Fecha = new Date()
                equipo.NroDocumento = doc.numero_de_peticion

                equipoStockPersonal = equipo
            }
        } else {
            const stockAlmacen = await indexedDB.stock_almacen.get({ ID_StockAlmacen: inventory.ID_Stock })
            if (!stockAlmacen) throw new Error('Stock almacen no encontrado')

            if (stockAlmacen.Item.Ind_SB === 'S') {
                const { equipo } = await selectStockAlmacenEquipos(inventory.ID_Stock, inventory.invsn)

                equipo.Estado = { ID_Estado: 2, Nombre: 'VALIDADO' }
                equipo.Validado.Fecha = new Date()
                equipo.NroDocumento = doc.numero_de_peticion

                equipoStockAlmacen = equipo
            }
        }
    }

    await indexedDB.transaction(
        'rw',
        indexedDB.somacyl_orders,
        indexedDB.stock_personal_equipos,
        indexedDB.stock_almacen_equipos,
        async () => {
            doc.inventory = doc.inventory.filter((e) => e.ID_Stock !== ID_Stock || e.invsn !== invsn)
            // doc.entregables = new SomacylEntregablesDTO()

            await indexedDB.somacyl_orders.put({
                ...doc,
                pendingSync: 1,
                updatedAt: Date.now()
            })

            if (item.Ind_SB === 'S') {
                if (ownPersonal) {

                    if (!equipoStockPersonal) {
                        throw new Error('Equipo stock personal no encontrado')
                    }

                    const row = await indexedDB.stock_personal_equipos.get({
                        ID_StockPersonal: ID_Stock
                    })

                    if (!row) {
                        throw new Error('Stock personal equipos no encontrado')
                    }

                    row.Equipos = row.Equipos.map((e) =>
                        e.Serie === equipoStockPersonal?.Serie
                            ? equipoStockPersonal
                            : e
                    )

                    await indexedDB.stock_personal_equipos.put(row)
                } else {
                    if (inventory.invpool === 'install') {
                        if (!equipoStockAlmacen) {
                            throw new Error('Equipo stock almacen no encontrado')
                        }

                        const row = await indexedDB.stock_almacen_equipos.get({
                            ID_StockAlmacen: ID_Stock
                        })

                        if (!row) {
                            throw new Error('Stock almacen equipos no encontrado')
                        }

                        row.Equipos = row.Equipos.map((e) =>
                            e.Serie === equipoStockAlmacen?.Serie
                                ? equipoStockAlmacen
                                : e
                        )

                        await indexedDB.stock_almacen_equipos.put(row)
                    }
                }
            }
        }
    )
    return await indexedDB.somacyl_orders.get(_id)
}

async function selectStockPersonalEquipos(ID_Stock: number, Serie: string) {
    const row = await indexedDB.stock_personal_equipos.get({ ID_StockPersonal: ID_Stock })
    if (!row) {
        throw new Error(`No se pudo obtener stock personal equipos`)
    }
    row.Equipos = row.Equipos.filter((e) => e.Serie === Serie)
    if (row.Equipos.length !== 1) {
        throw new Error(`No se pudo obtener stock personal equipos, hay ${row.Equipos.length} registros en Equipos con Serie ${Serie}`)
    }
    if (row.Equipos[0].Estado.ID_Estado !== 13) {
        throw new Error(`El equipo no está en estado disponible`)
    }
    return { stockPersonalEquipos: row, equipo: row.Equipos[0] }
}

async function selectStockAlmacenEquipos(ID_Stock: number, Serie: string) {
    const row = await indexedDB.stock_almacen_equipos.get({ ID_StockAlmacen: ID_Stock })
    if (!row) {
        throw new Error(`No se pudo obtener stock almacen equipos`)
    }
    row.Equipos = row.Equipos.filter((e) => e.Serie === Serie)
    if (row.Equipos.length !== 1) {
        throw new Error(`No se pudo obtener stock almacen equipos, hay ${row.Equipos.length} registros en Equipos con Serie ${Serie}`)
    }
    if (row.Equipos[0].Estado.ID_Estado !== 13) {
        throw new Error(`El equipo no está en estado disponible`)
    }
    return { stockAlmacenEquipos: row, equipo: row.Equipos[0] }
}